export enum CategoryActionType {
  EDIT = 'Edit',
  DELETE = 'Delete'
}

export enum CategoryInputErrors {
  Category_Name_Error = 'Please enter a valid name'
}
